import {SOCKET_CONNECTED} from '../actions/socket';

const INITIAL_STATE = null;

const defaultExports = function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case SOCKET_CONNECTED:
			return action.payload;
		default:
			return state;
	}
};
export default defaultExports;
